import produce from 'immer';

export const createAction = (actionType) => (actionParams) => {
    return {
        type: actionType,
        ...actionParams
    };
};
export const createApiCallAction = (actionType) => (actionParams) => {
    const meta = actionParams ? (actionParams.meta || {}) : {};
    meta.isApiCall = true;
    return createAction(actionType)({ ...actionParams, meta });
};


const normlizeTypePart = (source) => source.replace(/([a-z])([A-Z])/g, '$1_$2').toUpperCase();

export const createActionType = (actionName) => (...prefixes) => {
    const actionNameNormalized = normlizeTypePart(actionName);
    const actionType = `${
        prefixes.length
            ? `${prefixes.map((prefix) => normlizeTypePart(prefix)).join('__')}__`
            : ''
    }${actionNameNormalized}`;
    return actionType;
};

export const addIntercomEvent = (event) => produce((draft) => {
    draft.meta = draft.meta || {};
    draft.meta.intercom = event;
});